import {AppHeaderCrossBrandListSiBox} from "./app-header-cross-brand-list.si.box";

export const AppHeaderCrossBrandListSiCisBox = AppHeaderCrossBrandListSiBox;